






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {CargaCorreios} from '@/model/resource/CargaCorreios'
import {InputCargaCorreiosSchema} from '@/schema/resource/CargaCorreios/InputCargaCorreiosSchema'

@Component
export default class PersistCargaCorreiosView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputCargaCorreiosSchema()
  cargaCorreios = new CargaCorreios()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionCarga.listCarga()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.cargaCorreios.getCargaCorreios(id)
    }

    $.await.done('getCargaCorreios')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.cargaCorreios.persistCargaCorreios()
    await Helper.successAndPush(
      'system.success.persist',
      '/carga-correios/list'
    )
  }
}
